document.addEventListener('DOMContentLoaded', () => {
  const NAME_FEE_VARIANT_ID = 45162388127944;
  const PHRASE_FEE_VARIANT_ID = 45162388160712;

  // Global cost tracker
  window.extraEngravingCost = 0;

  // 1. Engraving Controls
  const radios = document.querySelectorAll('input[name="engraving_toggle"]');
  const engravingFields = document.getElementById("engravingFields");
  const engravingInput = document.getElementById("engravingInput");
  const charCount = document.getElementById("charCount");
  const maxCharCount = document.getElementById("maxCharCount");
  const engravingLabel = document.getElementById("engravingLabel");
  const embroideryNotice = document.getElementById("embroideryNotice");

  radios.forEach(radio => {
    radio.addEventListener("change", () => {
      if (radio.value === "no") {
        if (engravingFields) engravingFields.style.display = "none";
        if (embroideryNotice) embroideryNotice.style.display = "none";
        if (engravingInput) engravingInput.value = "";
        if (charCount) charCount.textContent = "0";
        window.extraEngravingCost = 0;
      } else {
        if (engravingFields) engravingFields.style.display = "block";
        if (embroideryNotice) embroideryNotice.style.display = "flex";
        window.extraEngravingCost = parseInt(radio.dataset.price) || 0;

        if (radio.value === "name") {
          if (engravingInput) engravingInput.maxLength = 14;
          if (maxCharCount) maxCharCount.textContent = "14";
          if (engravingLabel) engravingLabel.textContent = "Nombre (Hasta 14 caracteres)";
        } else if (radio.value === "phrase") {
          if (engravingInput) engravingInput.maxLength = 50;
          if (maxCharCount) maxCharCount.textContent = "50";
          if (engravingLabel) engravingLabel.textContent = "Frase (Hasta 50 caracteres)";
        }

        if (engravingInput && engravingInput.value.length > engravingInput.maxLength) {
          engravingInput.value = engravingInput.value.substring(0, engravingInput.maxLength);
          if (charCount) charCount.textContent = engravingInput.value.length;
        }
      }

      // If a custom template update function exists, invoke it
      if (typeof updateVariant === 'function') {
        updateVariant();
      }
    });
  });

  if (engravingInput) {
    engravingInput.addEventListener("input", () => {
      if (charCount) charCount.textContent = engravingInput.value.length;
    });
  }

  // 2. Color Selector
  const engravingColorBtns = document.querySelectorAll('.engraving-color-btn');
  const engravingColorInput = document.getElementById("engravingColorInput");
  const selectedEngravingColorDisplay = document.getElementById("selectedEngravingColorName");

  engravingColorBtns.forEach(button => {
    button.addEventListener("click", () => {
      engravingColorBtns.forEach(btn => btn.classList.remove("active"));
      button.classList.add("active");

      const selectedColorName = button.getAttribute("data-name");
      if (engravingColorInput) engravingColorInput.value = selectedColorName;
      if (selectedEngravingColorDisplay) selectedEngravingColorDisplay.textContent = selectedColorName;
    });
  });

  // 3. ULTRA-AGGRESSIVE CART INTERCEPTION (With explicit properties attached)
  document.addEventListener('click', function(e) {
    const addToCartBtn = e.target.closest('button[name="add"], .product-form__submit, .add-to-cart-btn');
    
    if (addToCartBtn && window.extraEngravingCost > 0) {
      const productForm = addToCartBtn.closest('form[action*="/cart/add"]');
      if (!productForm) return;

      e.preventDefault(); 
      e.stopImmediatePropagation();

      const originalText = addToCartBtn.innerHTML;
      addToCartBtn.disabled = true;
      addToCartBtn.innerHTML = '<span>Procesando bordado...</span>';

      const formData = new FormData(productForm);
      
      // MANUALLY GRAB AND FORCE THE PROPERTIES INTO THE CART (Fix applied here)
      const textToEngrave = document.getElementById('engravingInput') ? document.getElementById('engravingInput').value : null;
      const colorToEngrave = document.getElementById('engravingColorInput') ? document.getElementById('engravingColorInput').value : null;
      
      if (textToEngrave) {
          // Using .set() ensures we overwrite any blank values the theme might have tried to send
          formData.set('properties[Texto Grabado]', textToEngrave);
          if (colorToEngrave) {
              formData.set('properties[Color del Texto]', colorToEngrave);
          }
      }

      // Request 1: Submit the main product
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(response => {
        if (!response.ok) throw new Error('Error al añadir producto principal');
        return response.json();
      })
      .then(() => {
        // Request 2: Submit the extra surcharge variant
        let feeVariantId = null;
        if (window.extraEngravingCost === 15000) feeVariantId = NAME_FEE_VARIANT_ID;
        if (window.extraEngravingCost === 30000) feeVariantId = PHRASE_FEE_VARIANT_ID;

        if (feeVariantId) {
          return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [{
                id: feeVariantId,
                quantity: 1,
                properties: { 'Servicio': 'Personalización de bordado' }
              }]
            })
          }).then(res => {
            if (!res.ok) throw new Error('Error al añadir cargo de bordado');
            return res.json();
          });
        }
      })
      .then(() => {
        window.location.href = window.Shopify.routes.root + 'cart';
      })
      .catch(err => {
        console.error(err);
        addToCartBtn.disabled = false;
        addToCartBtn.innerHTML = originalText;
        alert('Hubo un problema al añadir al carrito. Verifica el stock del servicio extra.');
      });
    }
  }, true); 
});

// 4. Lightbox logic
function openLightbox(imageSrc) {
  const lightbox = document.getElementById('imageLightbox');
  const lightboxImg = document.getElementById('lightboxImage');
  if (lightbox && lightboxImg) {
    // THIS IS THE MAGIC FIX: Moves the modal out of the form and into the main body
    document.body.appendChild(lightbox);

    lightboxImg.src = imageSrc;
    lightbox.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }
}

function closeLightbox() {
  const lightbox = document.getElementById('imageLightbox');
  if (lightbox) {
    lightbox.style.display = 'none';
    document.body.style.overflow = 'auto';
  }
}

document.addEventListener('keydown', function(event) {
  if (event.key === "Escape") closeLightbox();
});